import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { bindActionCreators } from 'redux';

import * as symbols from '../../operations/symbols';
import { ORDER_STATUS } from '../../operations/constants';
import * as actions from '../../actions/ordersAction';
import * as compressionAction from '../../actions/compressionAction';
import CommonHeaderComponent from '../headers/CommonHeaderComponent';
import PictureModeModal from '../core/PictureModeModal';
import { PhotoViewer } from '../core/PhotoViewerComponent';
import LoaderComponent from '../core/LoaderComponent';
import Call from "sushiweb/Icons/all/Call";
import DirectionLine from 'sushiweb/Icons/all/DirectionLine';

class OrderDetailComponent extends Component {

  constructor(props) {
    super(props);

    this.state = {
      openPictureModeModal: false,
      position: {
        longitude: 0,
        latitude: 0
      },
      phones: [],
      noPhonesData: false,
      imagesUploaded: [],
      showCommentAddBtn: false,
      remark: '',
      showStoreImageModal: false,
      storeImages: []
    }
  }

  componentDidMount() {
    this.props.actions.getOrderDetails(this.props.match.params.id);
    this.props.actions.getOrderPhones(this.props.match.params.id);
    this.props.actions.resetCompressedImagesAction();
  }

  addRemark(e) {
    e.preventDefault();
    const payload = {
      orderId: this.props.match.params.id,
      remark: this.state.remark,
      remarkBy: 'Da',
    }
    this.props.actions.addRemarks(payload)
  }

  cancelRemark() {
    this.setState({ remark: '' })
  }

  getVerifiedBtn(status) {
    let statusTitle = "";
    let className = "";
    switch (status) {
      case ORDER_STATUS.delivered:
        statusTitle = "Delivered";
        className = "btn btn-info btn-sm nohover";
        break;
      case ORDER_STATUS.cancelled:
        statusTitle = "Cancelled";
        className = "btn btn-red-smoke btn-sm nohover";
        break;
      case ORDER_STATUS.pending:
        statusTitle = "Pending";
        className = "btn btn-yellow btn-sm nohover";
        break;
      case ORDER_STATUS.reattempt:
        statusTitle = "Re-Attempt"
        className = "btn btn-yellow btn-sm nohover";
        break;
      default:
        break;
    }
    return (
        <div className={className}>
          {statusTitle}
        </div>
    )
  }

  closePictureModeModal() {
    this.setState({ openPictureModeModal: false })
  }

  sendToOrder() {
    this.handleSelectedImage();
  }

  componentDidUpdate(prevProps) {
    const {
      uploadImagesStatus,
      remarkStatus,
      getPhonesStatus,
      orders,
      orderDetailImagesStatus,
      imageCompressionStatus
    } = this.props;

    if (uploadImagesStatus !== prevProps.uploadImagesStatus && uploadImagesStatus === symbols.STATUS_DONE) {
      this.props.actions.removeImageFromOrder(this.props.match.params.id);
      this.props.actions.getOrderDetails(this.props.match.params.id);
    }
    if (orders.orderPhones && getPhonesStatus !== prevProps.getPhonesStatus && getPhonesStatus === symbols.STATUS_DONE) {
      this.setState({ phones: orders.orderPhones })
    }
    if (getPhonesStatus !== prevProps.getPhonesStatus && getPhonesStatus === symbols.STATUS_FAIL) {
      this.setState({ noPhonesData: true })
    }

    if (uploadImagesStatus !== prevProps.uploadImagesStatus && uploadImagesStatus === symbols.STATUS_FAIL) {
      document.getElementById('takePicture').value = '';
      this.props.actions.resetOrderDetailImages();
    }

    if (remarkStatus !== prevProps.remarkStatus && remarkStatus === symbols.STATUS_DONE) {
      document.getElementById('add-comment').blur();
      this.cancelRemark()
    }
    if (orderDetailImagesStatus !== prevProps.orderDetailImagesStatus && orderDetailImagesStatus === symbols.STATUS_DONE) {
      this.sendToOrder();
      this.props.actions.resetOrderDetailImagesStatus();
    }
    if (imageCompressionStatus !== prevProps.imageCompressionStatus && imageCompressionStatus === symbols.STATUS_DONE) {
      this.setState({ imagesUploaded: this.props.compressedImages }, () => {
        this.props.actions.setOrderDetailImages(this.props.match.params.id, this.props.compressedImages, this.props.type);
        document.getElementById('takePicture').value = '';
      })
    }
  }


  handleSelectedImage(e) {
    let payload = new FormData();
    payload.append('orderId', this.props.match.params.id);
    if (this.props.orders.uploadedImages[this.props.match.params.id].length == 1) {
      payload.append('files', this.props.orders.uploadedImages[this.props.match.params.id][0]);
    } else {
      for (let i = 0; i < this.props.orders.uploadedImages[this.props.match.params.id].length; i++) {
        payload.append('files', this.props.orders.uploadedImages[this.props.match.params.id][i]);
      }
    }

    payload.append('latitude', this.state.position.latitude);
    payload.append('longitude', this.state.position.longitude);
    payload.append('imageType', "order_image");
    this.props.actions.uploadImages(payload)
  }

  filterStoreImages = () => {
    const { orderDetails = {} } = this.props.orders;
    const { images = []} = orderDetails;
    let storeImages = images.reduce((acc, ele) => {
      if (ele.entityType === 'store_image') {
        acc.push(ele)
      }
      return acc
    }, []);
    return storeImages;
  }

  handleDeliverClick(paymentMode, orderNumber) {
    const id = this.props.match.params.id;
    let storeImages = this.filterStoreImages();
    if (storeImages.length === 0) {
      this.setState({ showStoreImageModal: true, storeImages })
    } else {
      this.props.history.push({
        pathname: '/order/' + id + '/products',
        state: { orderNumber }
      })
    }
  }

  showDirections = () => {
    const { orderDetails = {} } = this.props.orders;
    const { orderDetail = {} } = orderDetails;
    const { outletLatitude, outletLongitude } = orderDetail;
    window.location.href = `https://www.google.com/maps/search/?api=1&query=${outletLatitude},${outletLongitude}`;
  }

  // Image handlers - compress the images. These images will be set in "imagesUploaded" upon component update
  handleSelectedImageChange(e, type) {
    let files = e.target.files;
    this.props.actions.compressImagesAction(files, null);
  }

  handleImageInputClick(type) {
    document.getElementById(type).click((e) => {})
  }


  openPictureModeModal() {
    this.handleImageInputClick('takePicture');
  }

  toggleCommentAddBtn(e) {
    e.preventDefault();
    this.setState(prevState => ({ showCommentAddBtn: !this.state.showCommentAddBtn }))
  }

  handleCommentValue(e) {
    this.setState({ remark: e.target.value })
  }

  closeStoreImageModal(){
    this.setState({showStoreImageModal: false})
  }


  render() {
    const {
      orders,
      getOrdersStatus,
      uploadImagesStatus,
      imageCompressionStatus
    } = this.props;

    const { showCommentAddBtn, showStoreImageModal } = this.state;
    const id = this.props.match.params.id;
    const { orderDetails = {} } = this.props.orders;
    const { orderDetail = {} } = orderDetails;
    const { outletLatitude, outletLongitude } = orderDetail;
    if (getOrdersStatus == symbols.STATUS_BEGIN || !orders.orderDetails) {
      return (
        <LoaderComponent/>
      )
    }

    const storeImages = this.filterStoreImages();
    return (
      <div className="hp-container pd-top-global mh-100 white-wrap pd-bottom-global">
        <PictureModeModal
          isOpen={showStoreImageModal}
          closePictureModeModal={() => this.closeStoreImageModal()}
          id={id}
          orderNumber={orders.orderDetails.orderDetail.orderNumber}
          type={'store_image'}
          title = {'Upload Store image'}
          images={this.state.storeImages}
          redirectedURL={`/order/${id}/storeImage`}
          modalBody={() => {
            return <div className="center mt-neg-2">
              <p className="fs-16 mb-2 align-left">
                {/* TODO: check this */}
                Please take an image of the store and make sure the name of the outlet is visible clearly.
              </p>
              <img src="../../images/storeFrontSample.png" />
             </div>
          }}
        />
        <input hidden type="file" accept="image/*" capture="camera" id="takePicture" onChange={(e, type) => this.handleSelectedImageChange(e, this.props.type)}/>
        <CommonHeaderComponent title={`Order - ${orders.orderDetails.orderDetail.orderNumber}`} enableBack={true}/>
        <div className="order-card mt-neg-2">
          <div className="orders-body mt-1">
            <div className="row">
              <div className="col-xs-12">
                <div className=" subtitle">
                  Status &nbsp; <span>{this.getVerifiedBtn(orders.orderDetails.orderDetail.status)}
                   {orders.orderDetails.orderDetail.on_priority ? <div className="btn btn-red btn-sm nohover marg-10">Priority</div>: <div></div>}</span>
                </div>
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-xs-6">
                <div className=" subtitle">
                  Outlet
                </div>
                <div className=" value">
                  {
                    
                    orders.orderDetails.orderDetail.fetchedStatus ? orders.orderDetails.orderDetail.outletName:"fetching data"
                  }
                </div>
              </div>
              <div className="col-xs-6">
                <div className="subtitle">
                  Phone #
                </div>
                <div className=" value">
                <Call className="sushi-icon icon-fs-16 blue-text vertical-align-bottom"/>
                  <a href={`tel:${(this.state.phones.length)>0?this.state.phones[0].phoneNumber:""}`}> +91 {(this.state.phones.length)>0?this.state.phones[0].phoneNumber:""}</a>
                </div>
              </div>
            </div>

            <div className="row mt-2">
              <div className="col-xs-6">
                <div className="subtitle">
                  Address
                </div>
                <div className="value">
                  {orders.orderDetails.orderDetail.outletAddress ? orders.orderDetails.orderDetail.outletAddress : '-'}
                </div>
              </div>
              <div className="col-xs-6">
                <div className="subtitle">
                  Delivery Slot
                </div>
                <div className=" value">
                  {orders.orderDetails.orderDetail.slotTime ? orders.orderDetails.orderDetail.slotTime : '-'}
                </div>
              </div>
            </div>
            { outletLatitude !== 0  && outletLongitude !==0 &&
            <div className="mt-2 flex fs-16 blue-text w-600" onClick={() => this.showDirections()}>
              <DirectionLine className="get-direction"/> &nbsp; Location
            </div>
            }
            {/*CTA for verify delivery*/}
            <div className="fixed-verify-section flex-right z-highest order-card">
              {
                // Show loading on button when images are being compressed or being uploaded
                imageCompressionStatus == symbols.STATUS_BEGIN || uploadImagesStatus === symbols.STATUS_BEGIN  ?
                  <div className="btn btn-disabled btn-expand">
                    <FontAwesomeIcon icon="spinner" className="animate-spinner"/>
                  </div>
                  :
                  <React.Fragment>
                    {
                      showCommentAddBtn ?
                        <div className="align-right">
                          {
                            this.props.remarkStatus === symbols.STATUS_BEGIN ?
                              <div className="btn btn-green btn-sm">
                                <FontAwesomeIcon icon="spinner" className="animate-spinner"/>
                              </div> :
                              <div
                                className={this.state.remark.trim() === '' ? "btn btn-disabled btn-sm" : "btn btn-green btn-sm"}
                                onMouseDown={(e) => this.addRemark(e)}>Add Comment</div>
                          }
                        </div>
                        :
                        <React.Fragment>
                          {
                            orders.orderDetails.orderDetail.otpVerified ?
                              <React.Fragment>
                                <div className="btn btn-expand btn-disabled">
                                  Already Delivered
                                </div>
                              </React.Fragment>
                              :
                              <React.Fragment>
                                <div className="btn btn-expand btn-green"
                                     onClick={() => this.handleDeliverClick(orders.orderDetails.orderDetail.paymentMode, orders.orderDetails.orderDetail.orderNumber)}
                                >
                                  {storeImages.length ?  'Verify products' : 'Verify outlet'}
                                </div>
                              </React.Fragment>
                          }
                        </React.Fragment>
                    }
                  </React.Fragment>
              }
            </div>
            <div className="order-photos mt-2">
              <div className="subtitle">
                Comments
              </div>
              {
                orders.orderDetails.remarks.length > 0 && orders.orderDetails.remarks.map((ele, index) => {
                  return (
                    <React.Fragment key={index}>
                      <div className="mt-1" >
                        {ele.message}
                      </div>
                      <div className="mb-1 gray-text">
                        by {ele.userType}
                      </div>
                    </React.Fragment>
                  )
                })
              }
              <form className="mt-2 relative fs-14">
                <textarea
                  onChange={(e) => this.handleCommentValue(e)}
                  value={this.state.remark}
                  id="add-comment"
                  onFocus={(e) => this.toggleCommentAddBtn(e)}
                  onBlur={(e) => this.toggleCommentAddBtn(e)}
                >
                </textarea>
                <label className={this.state.showCommentAddBtn || this.state.remark && this.state.remark !== '' ? "animate-label up" : "animate-label"}>
                  <span className={this.state.showCommentAddBtn ? 'green-text' : ''}>Add comment</span>
                </label>
              </form>
            </div>

            <div className="light-line mt-2"></div>
                <div className="">
                  In case of any other issues feel free to &nbsp;<Call className="sushi-icon icon-fs-16 blue-text vertical-align-bottom"/>
                  <a href='tel:+911171565093' className="blue-link"> Call Us</a>
                </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(connect(
  state => ({
    getOrdersStatus: state.statuses.getOrderDetails.status,
    getOrdersError: state.statuses.getOrderDetails.error,
    remarkStatus: state.statuses.addRemarks.status,
    uploadImagesStatus: state.statuses.uploadImages.status,
    uploadImagesError: state.statuses.uploadImages.error,
    getPhonesStatus: state.statuses.getOrderPhones.status,
    getPhonesError: state.statuses.getOrderPhones.error,
    orderDetailImagesStatus: state.statuses.orderDetailImages.status,
    imageCompressionStatus: state.statuses.imageCompression.status,
    imageCompressionError: state.statuses.imageCompression.error,
    compressedImages: state.compressedImages.compressedImages,
    orders: state.orders,
  }),
  dispatch => ({
    actions: bindActionCreators({
      ...actions, ...compressionAction
    }, dispatch),
  }),
)(OrderDetailComponent));
